import { FunctionComponent } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const ConfirmationModal: FunctionComponent<{
  message: string
  btnMessage: string
  btnVariant?: 'outline-danger' | 'primary'
  onClose: () => void
  onConfirmation: () => void
}> = ({ message, btnMessage, btnVariant, onClose, onConfirmation }) => (
  <Modal show={true} onHide={onClose} centered>
    <Modal.Header closeButton>
      <Modal.Title>Confirmar ação</Modal.Title>
    </Modal.Header>
    <Modal.Body className="text-muted">{message}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>
        Cancelar
      </Button>
      <Button
        variant={btnVariant === 'outline-danger' ? 'danger-solid' : 'primary'}
        onClick={onConfirmation}
      >
        {btnMessage}
      </Button>
    </Modal.Footer>
  </Modal>
)

export default ConfirmationModal
